"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SplashScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _config = require("../config");
require("./style.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function SplashScreenCompoent() {
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "splash-screen"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "logo"
  }, _config.LOGO_PATH && /*#__PURE__*/_react.default.createElement("img", {
    src: _config.LOGO_PATH,
    alt: "logo",
    width: "220"
  })), /*#__PURE__*/_react.default.createElement(_Box.default, {
    id: "spinner",
    sx: {
      '& > div': {
        backgroundColor: 'palette.secondary.main'
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bounce1"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "bounce2"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "bounce3"
  })));
}
var SplashScreen = /*#__PURE__*/(0, _react.memo)(SplashScreenCompoent);
exports.SplashScreen = SplashScreen;